// Adjust height
$(function(){

  function adjust() {
    var h = window.innerHeight-99 ? window.innerHeight-99: $(window).height()-99;
    if (h > 651) {
      $(".l-keyvisual").css("height", h + "px");
    } else {
      $(".l-keyvisual").css("height", "651px");
    }
  }

  adjust();

  $(window).resize(function(){
    adjust();
  });

});

// Product hover
$(function(){

  function productListHover() {
    var w = window.innerWidth ? window.innerWidth: $(window).width();
    if ( w > 768 ) {
      $('li.product-list').hover(function(){
        $(this).animate({
          'width': '420px'
        }, 150).find('.product-pop').fadeIn(150);
      }, function(){
        $(this).animate({
          'width': '400px'
        }, 150).find('.product-pop').fadeOut(150);
      });

      $('.product-pop').css('display', 'none');

    }
  }

  productListHover();

  $(window).resize(function(){
    productListHover();
  });

});

// Media hover
$(function(){

  function mediaHover() {
    var w = window.innerWidth ? window.innerWidth: $(window).width();
    if ( w > 768 ) {
      $(document).on('mouseenter', 'div.m-image-card', function(){
        $(this).find("div.m-image-card-overlay").animate({
          'bottom': 0
        }, {
          duration: 150
        });
      });
      $(document).on('mouseleave', 'div.m-image-card',function(){
        $(this).find("div.m-image-card-overlay").animate({
          'bottom': '-100%',
        }, {
          duration: 150
        });
      });
    }
  }

  mediaHover();

});

// solution hover
$(function(){
  var w = window.innerWidth ? window.innerWidth: $(window).width();
  if ( w > 768 ) {
    $('.m-text-card').hover(function(){
      $(this).find('a.m-text-card-contact-link').fadeIn(150);
    }, function(){
      $(this).find('a.m-text-card-contact-link').fadeOut(150);
    });
  }
});


// Japan hover
$(function(){

  $(".area-circle").hover(function(){
    var circleSize = $(this).attr("r");
    $(this).animate({
      r: circleSize * 1.2
    }, {
      duration: 150
    });
  }, function(){
    var circleSize = $(this).attr("r");
    $(this).animate({
      r: circleSize * 0.8
    }, {
      duration: 150
    });
  });

});

// works hover
$(function(){
  $('.m-work-card').hover(function(){
    $(this).find("div.m-work-card-overlay").animate({
      'bottom': 0
    }, {
      duration: 150
    });
  }, function(){
    $(this).find("div.m-work-card-overlay").animate({
      'bottom': '-100%',
    }, {
      duration: 150
    });
  });
});

// viviho
$(function(){
  var w = window.innerWidth ? window.innerWidth: $(window).width();
  if ( w < 968 ) {
    $('.slick-list').css('overflow', 'initial');
  }
});

// strength firefox hack
$(function(){
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.indexOf('firefox') != -1) {
    $('.tategaki-wrap').css({
      'position': 'relative',
      'top': '-300px'
    });
  }
});
